export default __webpack_public_path__ + "static/media/guardofdancingsteel2.1152feb0.png";